import { useSelector } from 'react-redux';
import { CalendarDays } from 'lucide-react';
import { Button } from '@design-system';
import { selectSession } from '@/model';
import { useIsConsumerFlowEnabled } from '@/hooks/use-app-mode';

/** Booking page for the complimentary 15-minute session with an LTC Planning Expert. */
export const LTC_PLANNING_SESSION_URL =
  'https://calendly.com/lori-joinwaterlily/waterlily-consumer-15-minute-walkthrough';

/** Shown to d2c-mode consumers once they've paid to self-fund, on every screen after the paywall. */
export function PlanningSessionButton() {
  const isConsumerFlow = useIsConsumerFlowEnabled();
  const hasPaid = useSelector(selectSession).clientStripe?.hasActivePlan ?? false;
  if (!isConsumerFlow || !hasPaid) return null;

  return (
    <Button asChild variant="outline" className="h-9 rounded-full md:h-10">
      <a href={LTC_PLANNING_SESSION_URL} target="_blank" rel="noopener noreferrer">
        <CalendarDays />
        <span className="hidden sm:inline">Book your free 15-min session</span>
        <span className="sm:hidden">Book a session</span>
      </a>
    </Button>
  );
}
